import React from "react";
import { X, Minus, Plus, ShoppingBag } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import { useApp } from "../context/AppContext";
import { resolveImage } from "../lib/api";

export default function CartSheet() {
    const { cartOpen, setCartOpen, cart, updateQty, removeFromCart, cartSubtotal, cartCount } = useApp();
    const navigate = useNavigate();

    if (!cartOpen) return null;

    return (
        <div className="fixed inset-0 z-50 flex" data-testid="cart-sheet">
            <div className="flex-1 bg-black/30 backdrop-blur-sm" onClick={() => setCartOpen(false)} />
            <aside className="w-full max-w-md bg-[color:var(--ms-warm-white)] border-l border-[color:var(--ms-border)] flex flex-col h-full">
                <div className="flex items-center justify-between px-6 py-5 border-b border-[color:var(--ms-border)] bg-[color:var(--ms-cream)]">
                    <div>
                        <div className="overline">Il tuo carrello</div>
                        <h2 className="font-display text-2xl text-[color:var(--ms-charcoal)]">{cartCount} {cartCount === 1 ? "capo" : "capi"}</h2>
                    </div>
                    <button onClick={() => setCartOpen(false)} className="text-[color:var(--ms-charcoal)] hover:text-[color:var(--ms-sage-dark)]" data-testid="cart-close"><X size={20} /></button>
                </div>

                <div className="flex-1 overflow-y-auto px-6 py-4">
                    {cart.length === 0 ? (
                        <div className="text-center py-20 text-[color:var(--ms-muted)]">
                            <ShoppingBag size={36} className="mx-auto mb-4 opacity-40" />
                            <p className="text-sm">Il tuo carrello è vuoto.</p>
                            <Link to="/shop" onClick={() => setCartOpen(false)} className="overline mt-6 inline-block link-underline" data-testid="cart-shop-link">
                                SCOPRI LA COLLEZIONE
                            </Link>
                        </div>
                    ) : (
                        <ul className="divide-y divide-[color:var(--ms-border)]">
                            {cart.map((item, idx) => (
                                <li key={`${item.product_id}-${item.size}-${idx}`} className="flex gap-4 py-4" data-testid={`cart-item-${idx}`}>
                                    <img src={resolveImage(item.image)} alt={item.title} className="w-20 h-24 object-cover bg-[color:var(--ms-cream)]" />
                                    <div className="flex-1 flex flex-col">
                                        <div className="text-[10px] tracking-[0.2em] text-[color:var(--ms-sage-dark)] uppercase">{item.brand}</div>
                                        <div className="text-sm text-[color:var(--ms-charcoal)] font-medium">{item.title}</div>
                                        <div className="text-xs text-[color:var(--ms-muted)] mt-1">Taglia {item.size}</div>
                                        <div className="flex items-center justify-between mt-auto pt-2">
                                            <div className="flex items-center gap-2 border border-[color:var(--ms-border)]">
                                                <button onClick={() => updateQty(idx, item.quantity - 1)} className="px-2 py-1 text-[color:var(--ms-charcoal)] hover:bg-[color:var(--ms-cream)]" data-testid={`cart-qty-dec-${idx}`}><Minus size={12} /></button>
                                                <span className="text-sm text-[color:var(--ms-charcoal)] w-6 text-center">{item.quantity}</span>
                                                <button onClick={() => updateQty(idx, item.quantity + 1)} className="px-2 py-1 text-[color:var(--ms-charcoal)] hover:bg-[color:var(--ms-cream)]" data-testid={`cart-qty-inc-${idx}`}><Plus size={12} /></button>
                                            </div>
                                            <div className="text-sm text-[color:var(--ms-charcoal)] font-medium">€{(item.price * item.quantity).toFixed(2)}</div>
                                        </div>
                                    </div>
                                    <button onClick={() => removeFromCart(idx)} className="text-[color:var(--ms-muted)] hover:text-[color:var(--ms-terracotta)] self-start" data-testid={`cart-remove-${idx}`}><X size={14} /></button>
                                </li>
                            ))}
                        </ul>
                    )}
                </div>

                {cart.length > 0 && (
                    <div className="border-t border-[color:var(--ms-border)] px-6 py-5 space-y-4 bg-[color:var(--ms-cream)]">
                        <div className="flex justify-between text-sm">
                            <span className="text-[color:var(--ms-muted)]">Subtotale</span>
                            <span className="text-[color:var(--ms-charcoal)] font-medium">€{cartSubtotal.toFixed(2)}</span>
                        </div>
                        <p className="text-xs text-[color:var(--ms-muted)]">Spedizione e codici sconto calcolati al checkout.</p>
                        <button
                            onClick={() => { setCartOpen(false); navigate("/cart"); }}
                            className="w-full bg-[color:var(--ms-charcoal)] text-[color:var(--ms-warm-white)] py-4 text-xs tracking-[0.2em] font-medium hover:bg-[color:var(--ms-sage-dark)] transition-colors"
                            data-testid="cart-checkout-btn"
                        >
                            VAI AL CHECKOUT &nbsp;·&nbsp; €{cartSubtotal.toFixed(2)}
                        </button>
                    </div>
                )}
            </aside>
        </div>
    );
}
